import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsUnterseiteGebaude(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Ebene_1"
      viewBox="0 0 359.38 81.39"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__cls-3{fill:#6060d6}'
          }
        </style>
      </defs>
      <g
        data-name="Geb\xE4ude Sammlung Desktop"
        id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Geb\xE4ude_Sammlung_Desktop"
      >
        <g id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Group-7">
          <g id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Group-8">
            <path
              d="M171.98 34.57h5.63c-1.22-7.08-7.28-11.99-15.13-11.99-9.41 0-16.28 7.08-16.28 18.7 0 11.5 6.68 18.66 16.53 18.66 8.83 0 15.13-5.79 15.13-14.97v-4.14h-14.29v4.53h8.98c-.12 5.86-4 9.57-9.82 9.57-6.41 0-11.08-4.85-11.08-13.69s4.7-13.65 10.87-13.65c4.4-.19 8.34 2.72 9.46 6.97ZM196.38 60c5.95 0 10.16-2.93 11.36-7.37l-5.03-.91c-.96 2.58-3.27 3.89-6.29 3.89-4.55 0-7.6-2.95-7.74-8.2h19.39v-1.88c0-9.85-5.9-13.71-12.07-13.71-7.6 0-12.61 5.79-12.61 14.17 0 8.47 4.94 14.01 12.98 14.01Zm-7.67-16.57c.05-4.01 3.32-7.23 7.33-7.23 4.12 0 6.82 3.05 6.84 7.23h-14.17Zm25.95 16.02h5.18v-4.24h.44a8.335 8.335 0 0 0 7.88 4.78c6.61 0 11.4-5.29 11.4-14.12s-4.86-14.05-11.45-14.05a8.173 8.173 0 0 0-7.83 4.78h-.32V23.09h-5.31v36.36Zm5.2-13.64c0-5.7 2.49-9.48 7.12-9.48s7.23 4.07 7.23 9.48c0 5.47-2.48 9.64-7.22 9.64s-7.12-3.9-7.12-9.64Zm33.83 14.24c4.51 0 7.05-2.29 8.06-4.33h.21v3.73h5.18V41.34c0-7.94-6.25-9.52-10.58-9.52-4.94 0-9.48 1.99-11.26 6.96l4.99 1.14c.78-1.93 2.77-3.8 6.34-3.8s5.18 1.79 5.18 4.88v.12c0 1.93-1.99 1.9-6.89 2.47-5.17.6-10.46 1.95-10.46 8.15 0 5.36 4.03 8.31 9.21 8.31Zm1.15-4.26c-3 0-5.17-1.35-5.17-3.98 0-2.84 2.52-3.85 5.59-4.26 1.72-.23 5.81-.69 6.57-1.46v3.52c0 3.23-2.57 6.18-7 6.18Zm-3.21-27.9c1.72 0 3.11-1.37 3.12-3.09a3.06 3.06 0 0 0-3.01-3.11h-.12c-1.72 0-3.12 1.38-3.14 3.11.06 1.7 1.44 3.06 3.14 3.09Zm10.44 0c1.72 0 3.11-1.37 3.12-3.09a3.06 3.06 0 0 0-3.01-3.11h-.12c-1.72 0-3.12 1.38-3.14 3.11.06 1.7 1.44 3.06 3.14 3.09Zm29.66 20.24c.23 3.54-2.46 6.6-6 6.82-.14 0-.27.01-.41.01-3.29 0-5.56-2.38-5.56-6.09V32.16h-5.31v17.35c0 6.76 3.71 10.28 8.95 10.28 3.51.17 6.75-1.86 8.15-5.08h.28v4.72h5.22V32.16h-5.33v15.96Zm22.89 11.84a8.31 8.31 0 0 0 7.88-4.78h.44v4.24h5.18V23.08h-5.31v13.51h-.32a8.232 8.232 0 0 0-7.85-4.78c-6.59 0-11.43 5.2-11.43 14.05 0 8.82 4.78 14.12 11.4 14.12Zm1.17-4.53c-4.74 0-7.21-4.17-7.21-9.64s2.41-9.48 7.21-9.48 7.12 3.78 7.12 9.48-2.54 9.64-7.12 9.64Zm31.89 4.55c5.95 0 10.16-2.93 11.36-7.37l-5.02-.91c-.96 2.58-3.27 3.89-6.29 3.89-4.54 0-7.6-2.95-7.74-8.2h19.39v-1.88c0-9.85-5.9-13.71-12.07-13.71-7.6 0-12.61 5.79-12.61 14.17 0 8.47 4.94 14.01 12.98 14.01Zm-7.67-16.57c.05-4.01 3.32-7.23 7.33-7.23 4.12 0 6.82 3.05 6.84 7.23h-14.17Z"
              data-name="Themen im Fokus-4"
              id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Themen_im_Fokus-4"
              style={{
                fill: '#005096',
              }}
            />
          </g>
        </g>
        <g
          data-name="Gruppe 495"
          id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Gruppe_495"
        >
          <g id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Passive-4">
            <g id="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__Rectangle-4">
              <rect
                height={81.39}
                rx={40.7}
                ry={40.7}
                style={{
                  fill: 'none',
                }}
                width={118.27}
              />
              <path
                className="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__cls-3"
                d="M77.58 81.39H40.7C18.26 81.39 0 63.14 0 40.7S18.26 0 40.7 0h36.88c22.44 0 40.69 18.26 40.69 40.7s-18.26 40.7-40.7 40.7ZM40.7 2.5C19.63 2.5 2.5 19.64 2.5 40.7s17.13 38.2 38.2 38.2h36.88c21.06 0 38.2-17.13 38.2-38.2S98.64 2.5 77.58 2.5H40.7Z"
              />
            </g>
            <path
              className="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__cls-3"
              d="M91.6 32.83 59.45 9.78c-.45-.33-1.07-.31-1.51.04l-12.26 9.75v-3.66c0-.69-.56-1.25-1.25-1.25h-6.37c-.69 0-1.25.56-1.25 1.25v9.59l-11.02 7.21a1.254 1.254 0 0 0 .69 2.3l19.64-.16c.27 0 .53-.09.74-.25l12.02-9 12.37 9.41c.22.17.48.26.76.26h5.55v23.9a1.25 1.25 0 0 0 2.5 0V35.26l10.84-.15c.54 0 1.01-.36 1.18-.88s-.03-1.08-.46-1.39Zm-12.81-.06h-6.37l-12.78-9.72c-.44-.34-1.06-.34-1.51 0l-12.44 9.32-14.98.12 8.03-5.26c.35-.23.57-.62.57-1.05v-9.01h3.87v5c0 .48.27.92.71 1.13.43.21.95.15 1.32-.15l13.55-10.77 28.3 20.29-8.26.12Z"
            />
            <path
              className="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__cls-3"
              d="M81.05 66.7H38.66V40.6a1.25 1.25 0 0 0-2.5 0v27.35c0 .69.56 1.25 1.25 1.25h43.64a1.25 1.25 0 0 0 0-2.5Z"
            />
            <path
              className="MS_Klimadashboard_Icons_Unterseite_Gebaude_svg__cls-3"
              d="M57.33 50.64c.69 0 1.25-.56 1.25-1.25v-8.47c0-.69-.56-1.25-1.25-1.25h-10.9c-.69 0-1.25.56-1.25 1.25v17.75c0 .69.56 1.25 1.25 1.25h11a1.25 1.25 0 0 0 0-2.5h-9.75V42.17h8.4v7.22c0 .69.56 1.25 1.25 1.25Z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsUnterseiteGebaude
